import { service } from '@ember/service';

import type { ImageCropData, PopupData, Service } from 'webapp-types';
import { BlockVisualization } from 'webapp/enums/enums';

import VisualizationBase from 'webapp/models-custom/visualization/base';

const RecordLimit = 0;

export default class VisualizationImage extends VisualizationBase {
	@service('navigation') declare navigationService: Service.Navigation;

	visualizationType = BlockVisualization.IMAGE;

	recordLimit = RecordLimit;

	get shownUrl() {
		return this.block.externalUrl;
	}

	get shownImage() {
		return this.block.imageUrl;
	}

	get filenameEnd(): string {
		const filename = this.shownImage.split('/');
		return filename?.pop() || '';
	}

	updateImages(
		imageUrl: string,
		imageOriginalUrl: string,
		imageCrop: ImageCropData | null,
	): void {
		const block = this.block;
		block.imageUrl = imageUrl;
		block.imageOriginalUrl = imageOriginalUrl;
		block.imageCrop = imageCrop;
		this.blockSetup.saveBlock();
	}

	openImageEdit(blobUrl = '', existingUrl = '', crop?: ImageCropData | null) {
		const onFinish: PopupData.Common.ImageUpload['onFinish'] = (url, originalUrl, crop) => {
			this.updateImages(url, originalUrl, crop);
		};
		this.navigationService.openImageUploadPopup(onFinish, blobUrl, existingUrl, crop);
	}

	static override recordLimit = RecordLimit;
}
